import React from 'react'
import Header from "../components/Layout/Header"
import Sidebar from '../components/Layout/Sidebar';
import SubscriptionCheckout from '../components/Checkout/SubscriptionCheckout';

const SubscriptionCheckoutPage = () => {
  
  return (
    <div className="subscription-checkout-page-container">
        <Header />
        <Sidebar />
        <main className="subscription-checkout-page-main">
          <SubscriptionCheckout />
        </main>
    </div>
  )
}

export default SubscriptionCheckoutPage ;